// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609012304/js/" + chunkId + "." + {"44":"716a1928","225":"c0d6d9f9","481":"a519d4ea","486":"a7f816c1","770":"9d594f7f"}[chunkId] + ".0.722930415674783.chunk.js";
};